import { render, staticRenderFns } from "./IsPremiseFurnishedQuestion.vue?vue&type=template&id=8a2f3040&scoped=true"
import script from "./IsPremiseFurnishedQuestion.vue?vue&type=script&lang=ts"
export * from "./IsPremiseFurnishedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2f3040",
  null
  
)

export default component.exports